export default {
  interviewMethod: '面接方式：',
  duration: '所要時間：',
  interviewTime: '面接時間：',
  meetingLink: '面接リンク：',
  note: '備考：',
  availableTimeSlots: '選択可能な面接時間帯：',
  mins: '分',
  rejectButton: '面接の招待を辞退する',
  acceptButton: '面接の招待を承諾する',
  rejectMessage: '面接の招待を辞退しました',
  selectTimeWarning: '時間帯を選択してください',
  acceptMessage: '面接の招待を承諾しました。選択した時間：{time}',
  fetchError: '面接情報の取得に失敗しました。後でもう一度お試しください',
  candidate: '候補者：',
  to: 'から',
  accepted: '面接の招待を承諾しました',
  rejected: '面接の招待を辞退しました',
  expired: '面接の招待は期限切れです',
  rejectionReason: '辞退理由：',
  online: 'オンライン',
  offline: 'オフライン',
  interviewInvitation: '面接の招待',
  rejectSuccess: '面接の招待を辞退しました',
  rejectError: '面接の辞退に失敗しました。後でもう一度お試しください',
  acceptSuccess: '面接の招待を承諾しました',
  acceptError: '面接の承諾に失敗しました。後でもう一度お試しください',
  invalidTimeSlot: '無効な時間帯',
  rejectDialogTitle: '面接の招待を辞退する',
  rejectReasonPlaceholder: '辞退理由',
  cancelButton: 'キャンセル',
  acceptDialogTitle: '面接の招待を承諾する',
  defaultNote: '時間通りに参加できない場合は、事前にお知らせください'
};
